import { RegistryTableOrder } from 'components/registry-table/registry-table.component';
import { SmartForm } from '@certemy/ui-components';
import { STEP_TYPES } from 'constants/status.constants';

export class TableFilters {
  page = 1;
  page_size = 10;
  search = '';
  order: RegistryTableOrder = { id: 'last_name', type: 'asc' };
  useDefaultRegistryFilters = '';
}

export interface RegistriesDetails {
  count: number;
  organization?: { logo: string; name: string };
  registries: Registry[];
}

export interface Registry {
  id: number;
  name: string;
  value: string;
  sort_id: string;
  historyStepType?: STEP_TYPES;
  type?: string;
}

export namespace RegistryRow {
  export interface Details {
    isHistoricalData: boolean;
    fileGenerationAllowed: boolean;
    certification: Certification;
    editableFields: EditableFields;
    customFields: CustomField[];
  }

  export interface Certification {
    title: RegistryField;
    acronym: RegistryField;
    status: RegistryField;
  }

  export interface CustomField {
    name: string;
    value: any;
    typeId: number;
  }

  export interface EditableFields {
    certificationNumber: RegistryField;
    issuedDate: RegistryField;
    originalIssueDate: RegistryField;
    expirationDate: RegistryField;
    previousExpirationDate: RegistryField;
    expirationStatus: RegistryField;
    verificationStatusId: RegistryField;
    renewalStatusId: RegistryField;
    disciplinaryAction: RegistryField;
    disciplinaryActionUrl: RegistryField;
  }

  export interface RegistryField {
    label: string;
    value: string;
    options?: SmartForm.FieldOption[];
  }
}
